import styled from '@emotion/styled';
import { borderRadius, color, ColorKeys } from 'components/core/theme';
import { mediaMobile } from 'components/core/theme/breakpoints';

export interface BadgeProps {
  textColor: ColorKeys;
  backgroundColor: ColorKeys;
}

export const Badge = styled.span<BadgeProps>`
  color: ${props => color(props.textColor)};
  background-color: ${props => color(props.backgroundColor)};
  border-radius: ${borderRadius.round};
  min-width: 1.5em;
  height: 1.5em;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMobile} {
    display: none;
  }
`;

export const Dot = styled.span`
  width: 0.6em;
  height: 0.6em;
  border-radius: ${borderRadius.round};
  background-color: red;
  position: absolute;
  top: 0;
  right: calc(50% - 20px);
`;

export const AppBar = styled.div``; //  className="w-full sm:pl-5 md:pl-5 lg:pl-5  pr-4"
